module.exports = __webpack_public_path__ + "img/02_SPHERES-LIQUID.1de883d2.gif";